module.exports = __webpack_public_path__ + "img/530.cfa71e98.jpg";